import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {APIConfig} from '../app.constant';
import {Observable} from 'rxjs/Observable';
import {PrinceStage} from '../models/princeStage.model';
import {HttpHeaders} from '@angular/common/http';
import {SessionService} from './session.service';

@Injectable()
export class PrinceStageService extends BaseService {

  getPrinceStages(): Observable<PrinceStage[]> {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
    return this.http.get<PrinceStage[]>(APIConfig.API_PRINCE_URL, this.options);
  }

}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/services/prince.service.ts